import * as actionTypes from "../../Action/actionTypes";
import React from "react";

const initialState = {

  corporate_user_headers:
    [
    {
      label: 'EMP ID',
      field: 'empID',
      sort: 'asc'
    },
    {
      label: 'First Name',
      field: 'fName',
      sort: 'asc'
    },
    {
      label: 'Last Name',
      field: 'lName',
      sort: 'asc'
    },
    {
      label: 'Mobile No',
      field: 'mobile',
      sort: 'asc'
    },
    {
      label: 'Department',
      field: 'department',
      sort: 'asc'
    },

    {
      label: 'Identification Type',
      field: 'idType',
      sort: 'asc'
    },
    {
      label: 'Identification Value',
      field: 'idValue',
      sort: 'asc'
    },
    {
      label: 'email',
      field: 'email',
      sort: 'asc'
    },

    {
      label: 'More Information',
      field: 'more',
      sort: 'asc'
    },
  ],
  view_all_corporates_users: [
    {
      empID: 'C001',
      fName: 'Tharindu',
      lName: 'Athukorala',
      mobile: '0777879675',
      department: 'Accounting',
      floor: 'Ground Floor',
      idType: 'NIC',
      idValue: '990090165v',
      email: 'tharindu@ceyentra.com',
      status: 'ACTIVE'
    },
    {
      empID: 'C002',
      fName: 'Chatura',
      lName: 'Colombage',
      mobile: '0777335467',
      department: 'IT',
      floor: 'Ground Floor',
      idType: 'NIC',
      idValue: '985642589v',
      email: 'chatura@ceyentra.com',
      status: 'INACTIVE'
    }
  ]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {


    case actionTypes.GET_ALL_CORPORATE_USERS:
      return {
        ...state,
        view_all_corporates_users: action.value
      };

    default:
      return state;
  }
};

export default reducer;
